import { PropsWithChildren, createContext, useContext, useState } from 'react';
import { BreadcrumbItem } from '../components/breadcrumbs/breadcrumbs';

interface CompanyContextType {
  breadcrumbs: any | null;
  setBreadcrumbs: (b: BreadcrumbItem[]) => void;
}

const _initialContextData: CompanyContextType = {
  breadcrumbs: null,
  setBreadcrumbs: () => null,
};

const BreadcrumbsContext = createContext<any>(_initialContextData);

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);

export const BreadcrumbsProvider = ({ children }: PropsWithChildren) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
